import {Injectable} from '@angular/core';
import {MenuItem} from '@models/sidebar/menu-item';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private behaviorSubject = new BehaviorSubject(new Array(new MenuItem()));
  routesNotification = this.behaviorSubject.asObservable();

  constructor() {
  }

  public broadcastRoutes(routes: MenuItem[]) {
    this.behaviorSubject.next(routes);
  }

  public generateRoutes(menuItem: MenuItem): MenuItem[] {
    const routes: MenuItem[] = [];
    this.addItemToRoutes(menuItem, routes);
    return routes;
  }

  public shortenRoutes(routes: MenuItem[]) {
    if (routes.length <= 4) {
      return routes;
    }
    const firstIndex = 0;
    const secondIndex = 1;
    const thirdIndex = 2;
    const fourthIndex = routes.length - 2;
    const fifthIndex = routes.length - 1;

    routes[thirdIndex].name = '...';
    return [
      routes[firstIndex], routes[secondIndex], routes[thirdIndex], routes[fourthIndex], routes[fifthIndex]
    ];
  }

  private addItemToRoutes(menuItem: MenuItem, routes: MenuItem[]) {
    if (menuItem.menuItemParent) {
      this.addItemToRoutes(menuItem.menuItemParent, routes);
    }
    routes.push(Object.assign(new MenuItem(), menuItem));
  }

}
